import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../service/tekkr-service";
import { UpdateAgentInput } from "tekkr-common/dist/model/agent/agent";

interface UpdateAgentParams {
    agentId: string;
    input: UpdateAgentInput;
}

interface Options {
    onSuccess?: () => void;
}

export function useUpdateAgentMutation(options?: Options) {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async ({ agentId, input }: UpdateAgentParams) => {
            const res = await apiClient.updateAgent({
                params: { agentId },
                body: input,
            });
            if (res.status !== 200) {
                throw new Error("Failed to update agent");
            }
            return res.body;
        },
        onSuccess: async (_, variables) => {
            await queryClient.invalidateQueries({ queryKey: ["agents"] });
            await queryClient.invalidateQueries({ queryKey: ["agent", variables.agentId] });
            options?.onSuccess?.();
        },
    });
}
